import { unstable_batchedUpdates } from 'react-dom';
import { configure } from 'mobx';

// mobx-react-lite 1.x does not install a React scheduler automatically. React 16
// otherwise commits each observer separately for socket and timer updates.
export const initializeReactBatching = () => configure({ reactionScheduler: unstable_batchedUpdates });

export const batchReactUpdates = unstable_batchedUpdates;
